<template>
	<div
		class="mg-toggle"
		:class="[sizeClass, { on: modelValue }]"
		@click="$emit('update:modelValue', !modelValue)"
	>
		<div class="mg-toggle-knob"></div>
	</div>
</template>

<script>
export default {
	name: 'MGToggle',
	props: {
		modelValue: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'large',
			validator: (v) => ['large', 'small'].includes(v)
		}
	},
	emits: ['update:modelValue'],
	computed: {
		sizeClass() {
			return `mg-toggle--${this.size}`;
		}
	}
}
</script>

<style scoped>
.mg-toggle {
	display: inline-flex;
	align-items: center;
	flex-shrink: 0;
	border-radius: 100px;
	transition: background 0.2s ease;
}

/* Large: 40x24 track, 20x20 knob */
.mg-toggle--large {
	width: 40px;
	height: 24px;
	border-radius: 100px;
	background: #E8E8E8;
	box-shadow: inset 0px 0.5px 2.5px 0px rgba(102, 102, 102, 0.75);
}

.mg-toggle--large .mg-toggle-knob {
	width: 20px;
	height: 20px;
	border-radius: 100px;
	margin-left: 2px;
	transition: margin-left 0.2s ease;
}

.mg-toggle--large.on {
	background: #5A506E;
}

.mg-toggle--large.on .mg-toggle-knob {
	margin-left: 18px;
}

/* Small: 24x16 track, 14x14 knob */
.mg-toggle--small {
	width: 24px;
	height: 16px;
	border-radius: 11px;
	background: #E8E8E8;
	box-shadow: inset 0px 0.5px 1.5px 0px rgba(0, 0, 0, 0.12), inset 0px 0px 1px 0px rgba(0, 0, 0, 0.02);
}

.mg-toggle--small .mg-toggle-knob {
	width: 14px;
	height: 14px;
	border-radius: 100px;
	margin-left: 1px;
	transition: margin-left 0.2s ease;
}

.mg-toggle--small.on {
	background: #5A506E;
	box-shadow: inset 0px 0.5px 2.5px 0px rgba(102, 102, 102, 0.75);
}

.mg-toggle--small.on .mg-toggle-knob {
	margin-left: 9px;
}

/* Knob shared styles */
.mg-toggle-knob {
	background: #FFFFFF;
	border: 0.5px solid rgba(0, 0, 0, 0.02);
	box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12);
}
</style>
